import { DropDownF } from '../../../../modules/Components/DropDown/F/Function/module/DronDownF.js';
import { CollapseF } from '../../../../modules/Components/Collapse/F/Function/module/CollapseF.js';

// 1. 컴포넌트 F 네임스페이스 로드 및 init 함수 생성
DropDownF.init();
CollapseF.init();
